import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import ReactToPrint from "react-to-print";
import AllResultsHistory from "./AllResultsHistory";
import "./PrintStudentResults.css";

// Academic year ranges
const YEAR_RANGES = {
  "24/25": { start: "2024-08-15", end: "2025-08-15" },
  "23/24": { start: "2023-08-15", end: "2024-08-15" },
  "22/23": { start: "2022-08-15", end: "2023-08-15" },
};

// Helper to determine the current academic year based on date
function getCurrentAcademicYear(date = new Date()) {
  const currentTimestamp = date.getTime();

  for (const [label, range] of Object.entries(YEAR_RANGES)) {
    const start = new Date(range.start).getTime();
    const end = new Date(range.end).getTime();

    if (currentTimestamp >= start && currentTimestamp < end) {
      return label;
    }
  }

  return "Unknown Year";
}

function PrintAllStudentResults(props) {
  const {
    individualStudentResult,
    assessmentResultsByStudent,
    student,
    classDetails,
    detailedView,
    buttonName,
    studentResults,
    students,
    schoolid,
    teacherid,
    toggleScoreType,
  } = props;

  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.toLocaleString("default", { month: "long" });
  const currentYear = currentDate.getFullYear();

  const componentRef = useRef();

  return (
    <>
      <StudentPrintable
        individualStudentResult={individualStudentResult}
        assessmentResultsByStudent={assessmentResultsByStudent}
        student={student}
        classDetails={classDetails}
        currentDay={currentDay}
        currentMonth={currentMonth}
        currentYear={currentYear}
        detailedView={detailedView}
        ref={componentRef}
        studentResults={studentResults}
        toggleScoreType={toggleScoreType}
        isPrintOut={true}
        teacherid={teacherid}
        schoolid={schoolid}
        students={students}
      />
    </>
  );
}

const StudentPrintable = React.forwardRef((props, ref) => {
  const academicYear = getCurrentAcademicYear();

  return (
    <div
      className="no-break-group"
      // style={{ minHeight: "100vh", position: "relative" }}
    >
      <div
        className="student-printable hide-div landscape-print"
        style={{ minHeight: "100vh", position: "relative", width: "100vw" }}
      >
        {/* Force full width in print and prevent page break between header/results */}
        <style>
          {`
            @media print {
              .landscape-print, .landscape-print > div, .results-history-table, .results-history-table table {
                width: 100vw !important;
                max-width: 100vw !important;
                min-width: 100vw !important;
                box-sizing: border-box !important;
              }
              .container, .container-shape, .row, .col, .results-history-table {
                padding-left: 0 !important;
                padding-right: 0 !important;
                margin-left: 0 !important;
                margin-right: 0 !important;
              }
              .alpaca-print-header {
                page-break-after: avoid !important;
                break-after: avoid !important;
              }
              .alpaca-print-header,
              .no-break-print-group {
                break-inside: avoid !important;
                page-break-inside: avoid !important;
              }
            }
          `}
        </style>
        <div ref={ref}>
          {/* Group header and results together to avoid page break */}
          <div className="no-break-print-group">
            <div>
              <AllResultsHistory
                studentResults={props.studentResults}
                toggleScoreType={props.toggleScoreType}
                assessmentResultsByStudent={props.assessmentResultsByStudent}
                isPrintOut={true}
                detailedView={props.detailedView}
                teacherid={props.teacherid}
                schoolid={props.schoolid}
                students={props.students}
                hideAccordion={!props.detailedView}
              />
            </div>
          </div>
          {/* Print footer inside printable area */}
          {/* <div
            className="alpaca-print-footer"
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              width: "100%",
              textAlign: "center",
              fontSize: "0.9rem",
              color: "#888",
              padding: "8px 0",
              background: "white",
              zIndex: 1000,
              display: "block",
            }}
          >
            Powered by ALPACA &copy; {new Date().getFullYear()}
          </div> */}
        </div>
      </div>
    </div>
  );
});

export default PrintAllStudentResults;
export { StudentPrintable };
